import { render, staticRenderFns } from "./GroupsSelection.vue?vue&type=template&id=c9428a70"
import script from "./GroupsSelection.vue?vue&type=script&lang=ts"
export * from "./GroupsSelection.vue?vue&type=script&lang=ts"
import style0 from "./GroupsSelection.vue?vue&type=style&index=0&id=c9428a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports